import { render, staticRenderFns } from "./HandshakeIcon.vue?vue&type=template&id=0d7f9fd6&"
import script from "./HandshakeIcon.vue?vue&type=script&lang=js&"
export * from "./HandshakeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports